import { components } from '@doltech/pageManagement/dto';
import * as React from 'react';

import { SampleCard, SampleCardProps } from './SampleCard';

interface SpeakingSampleCardProps extends SampleCardProps {
  data: components['schemas']['SpeakingSampleDTO'];
}

export const SpeakingSampleCard = (props: SpeakingSampleCardProps) => {
  const { data } = props;
  const { topic, year, quarter } = data;
  const metadata = [
    {
      id: 'TOPIC',
      text: topic?.name,
    },
    {
      id: 'QUARTER',
      text: quarter && year && `Quí ${quarter} ${year}`,
    },
  ];
  return <SampleCard metadata={metadata} {...props} />;
};
